import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import LocalizationList from './LocalizationList';
import LocalizationListService from '../services/LocalizationListService';

class LocalizationListContainer extends Component {
  static propTypes = {
    secondLocaleSelect: PropTypes.string,
  };

  static defaultProps = {
    secondLocaleSelect: 'es',
  };

  componentDidMount() {
    LocalizationListService.secondLocaleSelect =
      (['en', 'pt', 'es'].indexOf(this.props.secondLocaleSelect) < 0 && this.props.secondLocaleSelect) ||
      LocalizationListService.secondLocaleSelect;
    LocalizationListService.form.setValue('secondLocaleSelect', LocalizationListService.secondLocaleSelect);
    LocalizationListService.load();
  }

  render() {
    return (
      <LocalizationList
        items={toJS(LocalizationListService.items)}
        fetching={LocalizationListService.fetch.fetching}
        onDelete={LocalizationListService.handleRemove}
        onSave={LocalizationListService.handleSave}
        pagination={toJS(LocalizationListService.pagination)}
        onChange={LocalizationListService.handleChange}
        firstLocaleSelect={LocalizationListService.form.getValue('firstLocaleSelect')}
        secondLocaleSelect={LocalizationListService.form.getValue('secondLocaleSelect')}
      />
    );
  }
}

export default observer(LocalizationListContainer);
